import React from 'react';

interface Props {
    className?: string;
}

export const ResponseMessagesIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="20" height="20" viewBox="0 0 20 20">
            <path
                d="M10,0.6C3.8,0.6,0,1.9,0,8.1s3.8,7.5,10,7.5c1.1,0,2.1,0,3.1-0.1l3.4,3.9l1.7-5.8c1.2-1.1,1.9-2.9,1.9-5.4
                C20,1.9,16.2,0.6,10,0.6z M16.6,11.9l-0.4,0.4l-0.7,2.5L14,13.1l-1.2,0.1C12,13.3,11,13.3,10,13.3c-6.7,0-7.8-1.6-7.8-5.3
                S3.3,2.8,10,2.8s7.8,1.6,7.8,5.3C17.8,9.9,17.4,11.2,16.6,11.9z"
            />
            <path d="M6,9L6,9C5.4,9,5,8.6,5,8v0c0-0.6,0.4-1,1-1h0c0.6,0,1,0.4,1,1v0C7,8.6,6.6,9,6,9z" />
            <path d="M10,9L10,9C9.4,9,9,8.6,9,8v0c0-0.6,0.4-1,1-1h0c0.6,0,1,0.4,1,1v0C11,8.6,10.6,9,10,9z" />
            <path d="M14,9L14,9c-0.6,0-1-0.4-1-1v0c0-0.6,0.4-1,1-1h0c0.6,0,1,0.4,1,1v0C15,8.6,14.6,9,14,9z" />
        </svg>
    );
};
